import React, { memo } from "react";

// Libraries
import { useField } from "formik";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const Input = memo(
  ({ label, labelClass, className, showErrorMsg, ...props }) => {
    const [field, meta] = useField(props);

    return (
      <label
        className={`relative ${
          meta.touched && meta.error ? " errors-danger" : ""
        }${labelClass ? ` ${labelClass}` : "block"}`}
      >
        {label}
        <input
          className={`${className}${
            meta.touched && meta.error ? " errors-danger" : ""
          }`}
          {...field}
          {...props}
        />
        {meta.touched && meta.error && showErrorMsg ? (
          <span className='text-sm text-error block mt-[5px]'>
            {meta.error}
          </span>
        ) : null}
      </label>
    );
  }
);

export const TextArea = memo(
  ({ label, labelClass, className, showErrorMsg, ...props }) => {
    const [field, meta] = useField(props);

    return (
      <label
        className={`relative${
          meta.touched && meta.error ? " errors-danger" : ""
        }${labelClass ? ` ${labelClass}` : " block"}`}
      >
        {label}
        <textarea
          className={`${className}${
            meta.touched && meta.error ? " errors-danger" : ""
          }`}
          {...field}
          {...props}
        />
        {meta.touched && meta.error && showErrorMsg ? (
          <span className='text-sm text-error block mt-[5px]'>
            {meta.error}
          </span>
        ) : null}
      </label>
    );
  }
);

export const Checkbox = memo(
  ({ label, labelClass, className, children, ...props }) => {
    const [field, meta] = useField(props);

    return (
      <label
        className={`relative${
          meta.touched && meta.error ? " errors-danger" : ""
        }${labelClass ? ` ${labelClass}` : " block"}`}
      >
        <input
          type='checkbox'
          className={`${className}${
            meta.touched && meta.error ? " errors-danger" : ""
          }`}
          {...field}
          {...props}
        />
        {children}
      </label>
    );
  }
);

Input.defaultProps = {
  showErrorMsg: true,
};
